import { menusList } from '@/lib/fetch/menu'
import { MobileMenuContent } from './content'

export async function MobileMenu() {
  const data = await menusList()
  return <MobileMenuContent data={data} />
}
